import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const api = axios.create({
    baseURL: `${BASE}/api`,
    timeout: 60000,
});

const TOKEN_KEY = "owed:token";

export const getToken = () => {
    try { return localStorage.getItem(TOKEN_KEY) || null; } catch { return null; }
};

export const setToken = (token) => {
    try {
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
    } catch {
        /* ignore */
    }
};

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            setToken(null);
            if (typeof window !== "undefined" && !window.location.pathname.startsWith("/auth")) {
                // bounce to auth on session expiry
                window.location.href = "/auth";
            }
        }
        return Promise.reject(err);
    }
);

export const apiGet = (path, config) => api.get(path, config).then((r) => r.data);
export const apiPost = (path, body, config) => api.post(path, body, config).then((r) => r.data);
export const apiPut = (path, body, config) => api.put(path, body, config).then((r) => r.data);
export const apiDelete = (path, config) => api.delete(path, config).then((r) => r.data);
